import { emptyArray } from 'ui-components/default-props/empty';
import { CUSTOMER_PREVIOUS_ORDERS_SUCCESS, GET_CUSTOMER_PREVIOUS_ORDERS } from './customer-orders.grid.actions';
import * as CustomerActions from '../customers.actions';

const initialState = {
  isLoading: false,
  salesOrders: emptyArray,
  totalCount: 0,
};

const updateCustomerOrders = (state, { fulfillmentPlans, salesOrders, totalCount }) => ({
  ...state,
  fulfillmentPlans,
  salesOrders,
  totalCount,
  isLoading: false,
});

export const customerOrdersGrid = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_PREVIOUS_ORDERS:
      return { ...state, isLoading: true };
    case CUSTOMER_PREVIOUS_ORDERS_SUCCESS:
      return updateCustomerOrders(state, action);
    case CustomerActions.CLOSE_CUSTOMER_DETAILS_MODAL:
      return { ...state, salesOrders: emptyArray, totalCount: 0 };
    default:
      return state;
  }
};

export { namespace } from './customer-orders.reducer.metadata';
